@if (customisation.config|async; as c) {
  <div class="download-app-container" >
    @if (c.android_application_link || c.ios_application_link) {
      <span>{{'Download the App' | translate}}</span>
      @if (c.android_application_link) {
        <a [href]="c.android_application_link" target="_blank">
          <div class="img"><img src="assets/images/app-android.png"></div>
        </a>
      }
      @if (c.ios_application_link) {
        <a [href]="c.ios_application_link" target="_blank">
          <div class="img"><img src="assets/images/app-ios.png"></div>
        </a>
      }
    }
  </div>
}